import i18n from "../i18n/i18n";

const REGION_BY_LANGUAGE = {
  "en-ca": { countryCode: "CA", fallbackTimeZone: "America/Toronto" },
  "fr-ca": { countryCode: "CA", fallbackTimeZone: "America/Toronto" },
  "en-gb": { countryCode: "GB", fallbackTimeZone: "Europe/London" },
  "de-de": { countryCode: "DE", fallbackTimeZone: "Europe/Berlin" },
  "en-us": { countryCode: "US", fallbackTimeZone: "America/New_York" },
  "es-mx": { countryCode: "MX", fallbackTimeZone: "America/Mexico_City" },
  de: { countryCode: "DE", fallbackTimeZone: "Europe/Berlin" },
  fr: { countryCode: "CA", fallbackTimeZone: "America/Toronto" },
  es: { countryCode: "MX", fallbackTimeZone: "America/Mexico_City" },
  en: { countryCode: "US", fallbackTimeZone: "America/New_York" },
};

export function getBrowserRegion() {
  const language = (
    i18n.resolvedLanguage ||
    i18n.language ||
    (typeof navigator !== "undefined" && navigator.language) ||
    "en-US"
  ).toLowerCase();
  const region =
    REGION_BY_LANGUAGE[language] ||
    REGION_BY_LANGUAGE[language.split("-")[0]] ||
    REGION_BY_LANGUAGE.en;
  let timeZone = region.fallbackTimeZone;

  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || timeZone;
  } catch (error) {
    // Older browsers use the locale-based fallback above.
  }

  return {
    language,
    momentLocale: language,
    countryCode: region.countryCode,
    timeZone,
  };
}
